import axios from "axios";

import { HttpCodes } from "../../../modules/constants";

const EMAIL_EXISTS = "EMAIL_EXISTS";
const RESET_EMAIL_EXISTS = "RESET_EMAIL_EXISTS";

const getEmailExists = (state) => state.emailExists;

// Default state
const initialState = {
  emailExists: undefined,
};

export const addNonParticipantReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_EXISTS:
      return {
        ...state,
        emailExists: action.emailExists,
      };
    case RESET_EMAIL_EXISTS:
      return {
        ...state,
        emailExists: undefined,
      };
    default:
      return state;
  }
};

export const addNonParticipant =
  (email, roleName, siteIds, studyId) => (dispatch, getState) => {
    return axios
      .post(`/api/account/nonparticipants/invite`, {
        email: email,
        rolename: roleName,
        sites: siteIds,
        studyId: studyId,
      })
      .then(() => {
        return Promise.resolve("User invited successfully!");
      })
      .catch((err) => {
        let errorMessage =
          "There was an error while trying to invite the user!";
        if (err?.response?.status === HttpCodes.CONFLICT) {
          errorMessage =
            "The email address you have entered is already registered.";
        } else if (err?.response?.status === HttpCodes.PRE_CONDITION_FAILED) {
          errorMessage = "This email is not whitelisted. Please contact IT.";
        }
        return Promise.reject(errorMessage);
      });
  };

export const checkIfEmailExists = (email) => (dispatch, getState) => {
  const params = {
    email: email,
  };

  return axios
    .get(`/api/account/emailexists`, {
      params,
    })
    .then(() => {
      dispatch({ type: EMAIL_EXISTS, emailExists: false });
    })
    .catch((err) => {
      if (err?.response?.status === HttpCodes.CONFLICT) {
        dispatch({ type: EMAIL_EXISTS, emailExists: true });
      }
    });
};

export const resetEmailExists = () => (dispatch, getState) => {
  dispatch({ type: RESET_EMAIL_EXISTS });
};

export const mapStateToProps = (state) => {
  return {
    emailExists: getEmailExists(state),
  };
};

export const mapDispatchToProps = {
  addNonParticipant,
  checkIfEmailExists,
  resetEmailExists,
};
